import React from 'react';

export default class Modal extends React.Component {
    static defaultProps = {
        'show': false
    };

    constructor(props) {
        super(props);

        this.state = {
            show: this.props.show
        };
    }

    componentWillMount() {
        window.addEventListener('keyup', this.onModalKeyUp);
    }

    componentWillUnmount() {
        window.removeEventListener('keyup', this.onModalKeyUp);
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.show !== nextProps.show) {
            this.setState({show:nextProps.show});
        }
    }

    onModalKeyUp = (event) => {
        if(event.key === 'Enter') this.onClose();
    };

    onClose = (event) => {
        if(event) event.stopPropagation();
        if(event) event.preventDefault();

        if(
            event.target.getAttribute('class') &&
            (event.target.getAttribute('class').toString().trim() === "modal-shroud" ||
            event.target.getAttribute('class').toString().trim() === "modal-close")
        ){
            window.removeEventListener('keyup', this.onModalKeyUp);
            this.props.onClose ? this.props.onClose() : this.setState({ show: false } );
        }
    };

    render (){
        return (
            <div className={"modal-shroud " + (this.state.show ? '':'hidden')} onClick={ this.onClose }>
                <div className="modal">
                    <button className="modal-close" onClick={ this.onClose }>×</button>
                    <div className="modal-content">
                        { this.props.children }
                    </div>
                </div>
            </div>
        )
    }
}
